import { useCallback } from "react";
import { useDispatch, useSelector } from "react-redux";
import { navigate } from "gatsby";
import {
  getIfIsaAccountSelector,
  isIfIsaAccountLoadingSelector,
} from "@state/ifIsa/ifIsa.selectors";
import { fetchIfIsaAccountAPI } from "@state/ifIsa/ifIsa.actions";

/**
 * Custom hook to handle IF-ISA navigation logic
 *
 * This hook checks if the user has an IF-ISA account and either:
 * - Navigates to the IF-ISA page if they have an account
 * - Shows the setup modal if they don't have an account
 */
export const useIfIsaNavigation = (referrer?: string) => {
  const dispatch = useDispatch();
  const ifIsaAccount = useSelector(getIfIsaAccountSelector);
  const isLoading = useSelector(isIfIsaAccountLoadingSelector);

  const handleIfIsaClick = useCallback(
    (showSetupModal: () => void) => {
      // If we don't have account data yet, fetch it first
      if (!ifIsaAccount && !isLoading) {
        dispatch(fetchIfIsaAccountAPI());
        showSetupModal();
        return;
      }

      // If we have an account, navigate to the IF-ISA page
      if (ifIsaAccount && ifIsaAccount.id) {
        navigate(`/app/if-isa?${referrer ? `referrer=${referrer}` : ""}`);
      } else {
        // If no account, show the setup modal
        showSetupModal();
      }
    },
    [dispatch, ifIsaAccount, isLoading]
  );

  return {
    handleIfIsaClick,
    hasIfIsaAccount: !!(ifIsaAccount && ifIsaAccount.id),
    isLoading,
  };
};
